import { useEffect, useRef } from 'react';

interface AudioPlayerProps {
  src: string;
  autoPlay?: boolean;
  className?: string;
}

export function AudioPlayer({ src, autoPlay = false, className = '' }: AudioPlayerProps) {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (autoPlay && audioRef.current) {
      audioRef.current.play().catch(() => {
        // Browser may block autoplay — user gesture required
      });
    }
  }, [src, autoPlay]);

  return (
    <audio
      ref={audioRef}
      controls
      src={src}
      className={`w-full max-w-sm rounded-md ${className}`}
    />
  );
}
